import { render, staticRenderFns } from "./WarehouseInventoryPage.vue?vue&type=template&id=2730343f&scoped=true&"
import script from "./WarehouseInventoryPage.vue?vue&type=script&lang=js&"
export * from "./WarehouseInventoryPage.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseInventoryPage.vue?vue&type=style&index=0&id=2730343f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2730343f",
  null
  
)

export default component.exports